/** Figma reference panel size (762:36218) */
export const CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX = 830
export const CABIN_MEDIA_DRAWER_PANEL_MAX_WIDTH_PX = 441

/** width = height × (441/830) — Figma aspect ratio (~17/32) */
export const CABIN_MEDIA_DRAWER_PANEL_WIDTH_TO_HEIGHT_RATIO =
    CABIN_MEDIA_DRAWER_PANEL_MAX_WIDTH_PX / CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX

export const CABIN_MEDIA_DRAWER_PANEL_BORDER_RADIUS_PX = 32
export const CABIN_MEDIA_DRAWER_VERTICAL_MARGIN_PX = 32
export const CABIN_MEDIA_DRAWER_Z_INDEX = 1400
export const CABIN_MEDIA_DRAWER_OVERLAY_BG = 'rgba(26, 26, 26, 0.79)'

export const CABIN_MEDIA_DRAWER_TOP_GRADIENT =
    'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%)'

export const CABIN_MEDIA_DRAWER_BOTTOM_GRADIENT =
    'linear-gradient(0deg, rgba(0, 0, 0, 0.7) 33%, rgba(0, 0, 0, 0) 100%)'

export const CABIN_MEDIA_IMAGE_SLIDE_DURATION_MS = 5000

export const CABIN_MEDIA_PROGRESS_BAR_HEIGHT_PX = 4
export const CABIN_MEDIA_PROGRESS_GAP_PX = 12
export const CABIN_MEDIA_COPY_MAX_WIDTH_PX = 383

/** Figma 762:36642 — close button outside top-right of panel */
export const CABIN_MEDIA_DRAWER_CLOSE_BUTTON_SIZE_PX = 40
export const CABIN_MEDIA_DRAWER_CLOSE_ICON_SIZE_PX = 24
export const CABIN_MEDIA_DRAWER_CLOSE_BUTTON_GAP_PX = 40
export const CABIN_MEDIA_DRAWER_CLOSE_BUTTON_OFFSET_TOP_PX = -5
